<template>
  <div class="card modal-card">
    <div class="modal-card-body">
      <div class="card-content is-paddingless">
        <div class="mgb-50px">
          <h1 class="title is-size-3 has-text-centered">
            {{ $t('dcf.triLignes.title') }}
          </h1>
        </div>
      </div>
      <div class="mgb-20px">
        <error-msg-component
          :messages="messagesPopup"
          :error="isError"
          :title="'miseAJourTva.error.title'"
          :withEmplyFields="true"
          @close="isError = $event"/>
      </div>
      <div class="mgb-30px">
        <app-information-msg-component
          :libelleList="[{ isLink: false, libelle: $t('dcf.triLignes.msgInfo') }]"
          :canClose="false"
          title="general.info">
        </app-information-msg-component>
      </div>
      <div class="columns">
        <div class="column is-6">
          <b-field :label="$t('dcf.triLignes.selectProperty')">
            <b-select expanded v-model="propriete">
              <option
                v-for="tri in constantes.allTriPossible"
                :key="tri.value"
                :value="tri.value">
                {{ $t(tri.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('dcf.triLignes.sensTri.title')">
            <b-select expanded v-model="sensTri">
              <option
                v-for="sens in constantes.allSensTri"
                :key="sens.value"
                :value="sens.value">
                {{ $t(sens.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <footer>
        <button
          class="button btn-modal-annuler is-cancel has-text-centered button-modal mgl-0"
          @click="$parent.close()">
          {{ $t('general.button.cancel')}}
        </button>
        <button
          class="button is-addOrEdit has-text-centered button-modal"
          @click="gestionTri" >
          {{ $t('general.button.apply')}}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { ALL_TRI_POSSIBLES, ALL_SENS_TRI } from '@/configuration/dcf/dcfConf';

export default {
  data() {
    return {
      propriete: '',
      sensTri: '',
      isError: false,
      messagesPopup: [],
      constantes: {
        allTriPossible: ALL_TRI_POSSIBLES,
        allSensTri: ALL_SENS_TRI,
      },
    };
  },
  components: {
    errorMsgComponent,
    AppInformationMsgComponent,
  },
  methods: {
    gestionTri() {
      this.messagesPopup = [];
      if (!this.propriete || !this.sensTri) {
        this.isError = true;
        this.messagesPopup.push({ message: 'dcf.messages.errors.propertyTriNull' });
        return;
      }
      const args = {
        property: this.propriete,
        sens: this.sensTri,
      };
      this.$emit('gestionTriLignes', args);
      this.$parent.close();
    },
  },
};

</script>
